var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeclinedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Declined_Icon",
    transform: "translate(-1440 -167)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10185",
    "data-name": "Group 10185",
    transform: "translate(1440 167)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36412",
    "data-name": "Path 36412",
    d: "M17,0A17,17,0,1,1,0,17,17,17,0,0,1,17,0Z",
    transform: "translate(0 0)",
    fill: "#ed1f24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11517",
    "data-name": "Group 11517",
    transform: "translate(556.853 -976.362) rotate(45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36441",
    "data-name": "Path 36441",
    d: "M0,12a1,1,0,0,1-.478-.122,1,1,0,0,1-.4-1.357l6-11a1,1,0,0,1,1.357-.4,1,1,0,0,1,.4,1.357l-6,11A1,1,0,0,1,0,12Z",
    transform: "translate(1460.448 178.77) rotate(62)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36441-2",
    "data-name": "Path 36441",
    d: "M0,12a1,1,0,0,1-.478-.122,1,1,0,0,1-.4-1.357l6-11a1,1,0,0,1,1.357-.4,1,1,0,0,1,.4,1.357l-6,11A1,1,0,0,1,0,12Z",
    transform: "translate(1462.231 187.448) rotate(152)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeclinedIcon);
export default __webpack_public_path__ + "static/media/Declined_Icon.dbb0bd5c.svg";
export { ForwardRef as ReactComponent };